// extracted by mini-css-extract-plugin
module.exports = {"pagination":"S3_5Z","page-link":"J9oWk","page-item":"_t_Wi","active":"EYxdk","disabled":"TNpVN","pagination-lg":"__66E32","pagination-sm":"cqomT","page-link-next":"__398lt"};